import Page from '../components/Page';
import { useAuth0 } from '@auth0/auth0-react';
import { AppView } from '../constants';
import { ERROR_TYPE, ErrorFallback } from '../components/ErrorFallback';
import { Dialog } from '@mui/material';

export const Unauthorized = () => {
  const { logout } = useAuth0();
  return (
    <Page pageName={AppView.UnauthorizedError}>
      <Dialog open fullScreen>
        <ErrorFallback
          type={ERROR_TYPE.UNAUTHORIZED}
          onButtonClick={() =>
            logout({
              returnTo: window.location.origin,
            })
          }
        />
      </Dialog>
    </Page>
  );
};
